import React from 'react'
import Title from './Title'
import ProjectItem from './ProjectItem'
import college from '../icons/college.png'
import ems from '../icons/ems.png'
import dailynews from '../icons/dailynews.png'
import portfolio from '../icons/portfolio.png'
import weather from '../icons/weather.png'
function Project() {
  return (
    <div className='d-flex ' style={{flexDirection:"column"}}>
      <Title title="Core Java Project" />
      <div className="container d-flex justify-content-between border">

        <div className="row">
          <div className="item">
            <ProjectItem source="Github" link="https://github.com/nejaruli4460/College-Management-System" description="On this project I make full college management system here I use jdbc with mysql to maintain backend" title="College Mangement System Project" image={college} />
          </div>
          <div className="item">
            <ProjectItem source="Github" link="https://github.com/nejaruli4460/Employee_management_system" description="On this project I make a small employee management GUI which includes only basic MVC pattern" title="Employee Mangement System Project" image={ems} />
          </div>
        </div>
        </div>
        <Title title="React Js Project" />
        <div className="container d-flex justify-content-between border">

          <div className="row">
            <div className="item">
              <ProjectItem source="Website" link="https://myindiandailynews.web.app" description="On this project I create a news app here I use news REST API to maintain news ." title="React project on news API" image={dailynews} />
            </div>
            <div className="item">
              <ProjectItem source="Website" link="https://iamnejarul.web.app" description="On this project I make Portfolio where i maintain all my activity" title="My Portfolio Website" image={portfolio} />
            </div>
          </div>

        </div>
        <Title title="Core HTML CSS JAVASCRIPT Project" />
        <div className="container d-flex justify-content-between border">

          <div className="row">
            <div className="item">
              <ProjectItem source="Github-Website" link="https://nejaruli4460.github.io/weather_app/" description="On this project I create a weather app. here I use news REST API to maintain news ." title="Weather App using waether api" image={weather} />
            </div>
           
          </div>

        </div>
      </div>
   
  )
}

export default Project
